module.exports = __webpack_public_path__ + "static/OneDotExt.80b9d768.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/OneDotExt.woff2
// module id = 755
// module chunks = 114276838955818